module.exports = __webpack_public_path__ + "media/images/emblems/Tafers-coat_of_arms-8aee8268c7fe705c54d6de5d7575c4c4.svg";